module.exports = __webpack_public_path__ + "img/1518649357.c14b5c36.jpg";